import * as types from './actionsTypes'
import axios from 'axios'

export function setJobInDraft(data){
    return {
        type: types.SET_JOB_IN_DRAFT,
        payload: data
    }
}
export function refreshJobInDraft(jobId){
    return async (dispatch) => {
        const res = await axios.post(
            "/api/jobs/get/job/by/id",
            { jobId: jobId } 
        )

        dispatch({
            type: types.REFRESH_JOB_IN_DRAFT,
            payload: { jobDraft: res.data.job }
        })
    }
}


